import script from "./titleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./titleComponent.vue?vue&type=script&setup=true&lang=js"

import "./titleComponent.vue?vue&type=style&index=0&id=72b677ef&scoped=true&lang=css"

import exportComponent from "/home/test/projects/deploy/frontend/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b677ef"]])

export default __exports__